export enum EQueryUsageReportType {
    Protocol = 'Protocol',
    Sponsor = 'Sponsor',
    Project = 'Project',
    Country = 'Country',
    All = 'All',
}
